import { noop } from 'lodash-es';
import { ComponentProps, forwardRef } from 'react';
import { StyledButton, StyledButtonContent } from './Button.styles';

export type ButtonProps = ComponentProps<'a'> &
  ComponentProps<'button'> & { enforceLink?: boolean };

export const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(
  ({ onClick = noop, enforceLink = false, children, ...props }, ref) => {
    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      <StyledButton
        {...props}
        ref={ref}
        onClick={(event: { currentTarget: HTMLElement }) => {
          event.currentTarget.blur();
          onClick(event);
        }}
        enforceLink={enforceLink}
      >
        <StyledButtonContent>{children}</StyledButtonContent>
      </StyledButton>
    );
  },
);
